export const getDivisions = state => state.divisions.data;
export const getSelectedDivision = state => state.divisions.selectedDivision;
